/* tslint:disable */
/* eslint-disable */
/**
 * HAU.ITDE.SpareParts.Purchase.NonShop.Portal.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HotSpotShort } from '../model';
// @ts-ignore
import type { ProblemDetails } from '../model';
// @ts-ignore
import type { VwSparePartMultiComponentShort } from '../model';
// @ts-ignore
import type { VwSparePartShort } from '../model';
/**
 * RelationApi - axios parameter creator
 * @export
 */
export const RelationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get SparePart by Locale, Appliance Service Number and Position
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {number} position 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RelationGet: async (serviceNumberAppliance: string, locale: string, position: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceNumberAppliance' is not null or undefined
            assertParamExists('v1RelationGet', 'serviceNumberAppliance', serviceNumberAppliance)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('v1RelationGet', 'locale', locale)
            // verify required parameter 'position' is not null or undefined
            assertParamExists('v1RelationGet', 'position', position)
            const localVarPath = `/v1/relation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceNumberAppliance !== undefined) {
                localVarQueryParameter['serviceNumberAppliance'] = serviceNumberAppliance;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Hotspots by FileNames, Locale and Service Number Appliance
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RelationHotspotsPost: async (serviceNumberAppliance: string, locale: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceNumberAppliance' is not null or undefined
            assertParamExists('v1RelationHotspotsPost', 'serviceNumberAppliance', serviceNumberAppliance)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('v1RelationHotspotsPost', 'locale', locale)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('v1RelationHotspotsPost', 'requestBody', requestBody)
            const localVarPath = `/v1/relation/hotspots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceNumberAppliance !== undefined) {
                localVarQueryParameter['serviceNumberAppliance'] = serviceNumberAppliance;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Second Level Multicomponents (Z-parts and virtual products) by Locale and Appliance Service Number
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RelationMulticomponentsGet: async (serviceNumberAppliance: string, locale: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceNumberAppliance' is not null or undefined
            assertParamExists('v1RelationMulticomponentsGet', 'serviceNumberAppliance', serviceNumberAppliance)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('v1RelationMulticomponentsGet', 'locale', locale)
            const localVarPath = `/v1/relation/multicomponents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceNumberAppliance !== undefined) {
                localVarQueryParameter['serviceNumberAppliance'] = serviceNumberAppliance;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Filtered Positions (for Hotspots) by Locale and Appliance Service Number
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {string} search 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RelationPositionsFilterGet: async (serviceNumberAppliance: string, locale: string, search: string, page: number, pageSize: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceNumberAppliance' is not null or undefined
            assertParamExists('v1RelationPositionsFilterGet', 'serviceNumberAppliance', serviceNumberAppliance)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('v1RelationPositionsFilterGet', 'locale', locale)
            // verify required parameter 'search' is not null or undefined
            assertParamExists('v1RelationPositionsFilterGet', 'search', search)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('v1RelationPositionsFilterGet', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('v1RelationPositionsFilterGet', 'pageSize', pageSize)
            const localVarPath = `/v1/relation/positions/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceNumberAppliance !== undefined) {
                localVarQueryParameter['serviceNumberAppliance'] = serviceNumberAppliance;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Positions (for Hotspots) by Locale and Appliance Service Number
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RelationPositionsGet: async (serviceNumberAppliance: string, locale: string, page: number, pageSize: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceNumberAppliance' is not null or undefined
            assertParamExists('v1RelationPositionsGet', 'serviceNumberAppliance', serviceNumberAppliance)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('v1RelationPositionsGet', 'locale', locale)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('v1RelationPositionsGet', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('v1RelationPositionsGet', 'pageSize', pageSize)
            const localVarPath = `/v1/relation/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceNumberAppliance !== undefined) {
                localVarQueryParameter['serviceNumberAppliance'] = serviceNumberAppliance;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RelationApi - functional programming interface
 * @export
 */
export const RelationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RelationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get SparePart by Locale, Appliance Service Number and Position
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {number} position 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1RelationGet(serviceNumberAppliance: string, locale: string, position: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VwSparePartShort>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1RelationGet(serviceNumberAppliance, locale, position, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationApi.v1RelationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Hotspots by FileNames, Locale and Service Number Appliance
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1RelationHotspotsPost(serviceNumberAppliance: string, locale: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<HotSpotShort> | undefined; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1RelationHotspotsPost(serviceNumberAppliance, locale, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationApi.v1RelationHotspotsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Second Level Multicomponents (Z-parts and virtual products) by Locale and Appliance Service Number
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1RelationMulticomponentsGet(serviceNumberAppliance: string, locale: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<VwSparePartMultiComponentShort> | undefined; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1RelationMulticomponentsGet(serviceNumberAppliance, locale, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationApi.v1RelationMulticomponentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Filtered Positions (for Hotspots) by Locale and Appliance Service Number
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {string} search 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1RelationPositionsFilterGet(serviceNumberAppliance: string, locale: string, search: string, page: number, pageSize: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VwSparePartShort>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1RelationPositionsFilterGet(serviceNumberAppliance, locale, search, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationApi.v1RelationPositionsFilterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Positions (for Hotspots) by Locale and Appliance Service Number
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1RelationPositionsGet(serviceNumberAppliance: string, locale: string, page: number, pageSize: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VwSparePartShort>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1RelationPositionsGet(serviceNumberAppliance, locale, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelationApi.v1RelationPositionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RelationApi - factory interface
 * @export
 */
export const RelationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RelationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get SparePart by Locale, Appliance Service Number and Position
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {number} position 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RelationGet(serviceNumberAppliance: string, locale: string, position: number, options?: RawAxiosRequestConfig): AxiosPromise<VwSparePartShort> {
            return localVarFp.v1RelationGet(serviceNumberAppliance, locale, position, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Hotspots by FileNames, Locale and Service Number Appliance
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RelationHotspotsPost(serviceNumberAppliance: string, locale: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<HotSpotShort> | undefined; }> {
            return localVarFp.v1RelationHotspotsPost(serviceNumberAppliance, locale, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Second Level Multicomponents (Z-parts and virtual products) by Locale and Appliance Service Number
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RelationMulticomponentsGet(serviceNumberAppliance: string, locale: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<VwSparePartMultiComponentShort> | undefined; }> {
            return localVarFp.v1RelationMulticomponentsGet(serviceNumberAppliance, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Filtered Positions (for Hotspots) by Locale and Appliance Service Number
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {string} search 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RelationPositionsFilterGet(serviceNumberAppliance: string, locale: string, search: string, page: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<VwSparePartShort>> {
            return localVarFp.v1RelationPositionsFilterGet(serviceNumberAppliance, locale, search, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Positions (for Hotspots) by Locale and Appliance Service Number
         * @param {string} serviceNumberAppliance 
         * @param {string} locale 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RelationPositionsGet(serviceNumberAppliance: string, locale: string, page: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<VwSparePartShort>> {
            return localVarFp.v1RelationPositionsGet(serviceNumberAppliance, locale, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RelationApi - interface
 * @export
 * @interface RelationApi
 */
export interface RelationApiInterface {
    /**
     * 
     * @summary Get SparePart by Locale, Appliance Service Number and Position
     * @param {string} serviceNumberAppliance 
     * @param {string} locale 
     * @param {number} position 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationApiInterface
     */
    v1RelationGet(serviceNumberAppliance: string, locale: string, position: number, options?: RawAxiosRequestConfig): AxiosPromise<VwSparePartShort>;

    /**
     * 
     * @summary Get Hotspots by FileNames, Locale and Service Number Appliance
     * @param {string} serviceNumberAppliance 
     * @param {string} locale 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationApiInterface
     */
    v1RelationHotspotsPost(serviceNumberAppliance: string, locale: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<HotSpotShort> | undefined; }>;

    /**
     * 
     * @summary Get Second Level Multicomponents (Z-parts and virtual products) by Locale and Appliance Service Number
     * @param {string} serviceNumberAppliance 
     * @param {string} locale 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationApiInterface
     */
    v1RelationMulticomponentsGet(serviceNumberAppliance: string, locale: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<VwSparePartMultiComponentShort> | undefined; }>;

    /**
     * 
     * @summary Get Filtered Positions (for Hotspots) by Locale and Appliance Service Number
     * @param {string} serviceNumberAppliance 
     * @param {string} locale 
     * @param {string} search 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationApiInterface
     */
    v1RelationPositionsFilterGet(serviceNumberAppliance: string, locale: string, search: string, page: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<VwSparePartShort>>;

    /**
     * 
     * @summary Get Positions (for Hotspots) by Locale and Appliance Service Number
     * @param {string} serviceNumberAppliance 
     * @param {string} locale 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationApiInterface
     */
    v1RelationPositionsGet(serviceNumberAppliance: string, locale: string, page: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<VwSparePartShort>>;

}

/**
 * RelationApi - object-oriented interface
 * @export
 * @class RelationApi
 * @extends {BaseAPI}
 */
export class RelationApi extends BaseAPI implements RelationApiInterface {
    /**
     * 
     * @summary Get SparePart by Locale, Appliance Service Number and Position
     * @param {string} serviceNumberAppliance 
     * @param {string} locale 
     * @param {number} position 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationApi
     */
    public v1RelationGet(serviceNumberAppliance: string, locale: string, position: number, options?: RawAxiosRequestConfig) {
        return RelationApiFp(this.configuration).v1RelationGet(serviceNumberAppliance, locale, position, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Hotspots by FileNames, Locale and Service Number Appliance
     * @param {string} serviceNumberAppliance 
     * @param {string} locale 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationApi
     */
    public v1RelationHotspotsPost(serviceNumberAppliance: string, locale: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return RelationApiFp(this.configuration).v1RelationHotspotsPost(serviceNumberAppliance, locale, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Second Level Multicomponents (Z-parts and virtual products) by Locale and Appliance Service Number
     * @param {string} serviceNumberAppliance 
     * @param {string} locale 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationApi
     */
    public v1RelationMulticomponentsGet(serviceNumberAppliance: string, locale: string, options?: RawAxiosRequestConfig) {
        return RelationApiFp(this.configuration).v1RelationMulticomponentsGet(serviceNumberAppliance, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Filtered Positions (for Hotspots) by Locale and Appliance Service Number
     * @param {string} serviceNumberAppliance 
     * @param {string} locale 
     * @param {string} search 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationApi
     */
    public v1RelationPositionsFilterGet(serviceNumberAppliance: string, locale: string, search: string, page: number, pageSize: number, options?: RawAxiosRequestConfig) {
        return RelationApiFp(this.configuration).v1RelationPositionsFilterGet(serviceNumberAppliance, locale, search, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Positions (for Hotspots) by Locale and Appliance Service Number
     * @param {string} serviceNumberAppliance 
     * @param {string} locale 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationApi
     */
    public v1RelationPositionsGet(serviceNumberAppliance: string, locale: string, page: number, pageSize: number, options?: RawAxiosRequestConfig) {
        return RelationApiFp(this.configuration).v1RelationPositionsGet(serviceNumberAppliance, locale, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}

